import React from "react"
import PropTypes from "prop-types"

import Copy from "../atoms/copy"
import Image from "../atoms/image"
import Video from "../atoms/video"
import Downloads from "../organisms/downloads"
import Accordion from "../organisms/accordion"

function checkType(element) {
  switch (true) {
    case element.__typename.includes("Copy"):
      return <Copy copy={element.copy} />
    case element.__typename.includes("Image"):
      return <Image image={element.image} />
    case element.__typename.includes("Video"):
      return <Video video={element.video} />
    case element.__typename.includes("Downloads"):
      return <Downloads downloads={element.downloads} />
    case element.__typename.includes("Accordion"):
      return <Accordion accordion={element.accordion} />
    default: // Do nothing
  }
}

export default function FlexibleContent({ elements }) {
  return elements.map((element, index) => (
    <div key={index}>{checkType(element)}</div>
  ))
}

FlexibleContent.propTypes = {
  /**
   * The Flexible Content's elements
   */
  elements: PropTypes.array.isRequired,
}
